/**
 *  Filters getters module file
**/

export const getters = {}
